<template>
  <div :class="{'home': header == 'on'}">
    <van-nav-bar id="home-nav" :fixed="true" :title="$t('Track a flight')" :z-index="10000" v-if="header == 'on'"
                 @click-left="$router.back()" :left-arrow="true"/>
    <van-tabs type="card" color="#1E44D5" class="nav-tab" v-model="selected" :class="{'iosMargin': header !== 'on'}">
      <van-tab :title="$t('ScheduleMenu')">
        <Schedule></Schedule>
      </van-tab>
      <van-tab :title="$t('FlightNumber')">
        <FlightNumber></FlightNumber>
      </van-tab>
      <van-tab :title="$t('Route')">
        <Route></Route>
      </van-tab>
    </van-tabs>
  </div>
</template>
<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import Schedule from './Schedule'
import FlightNumber from './FlightNumber'
import Route from './Route'

export default {
  name: 'home',
  components: {
    Schedule,
    FlightNumber,
    Route
  },
  data () {
    return {
      selected: '0',
      header: null,
      screenName: ''
    }
  },
  methods: {
    gtmTrack () {
      this.$gtm.push({
        'event': 'screenview',
        'site_type': sessionStorage.getItem('site_type'),
        'brand': 'edreams',
        'screenName': this.screenName,
        'lang': localStorage.getItem('cod_lang') || localStorage.getItem('lang'),
        'cid': localStorage.getItem('cid')
      })
    }
  },
  created () {
    const reg = new RegExp('(^|&)header=([^&]*)(&|$)', 'i')
    const r = window.location.search.substr(1).match(reg)
    if (r) {
      this.header = decodeURI(r[2])
    }
    sessionStorage.setItem('header', this.header)
    sessionStorage.setItem('site_type', this.header === 'on' ? 'A_A' : 'A_I')
  },
  watch: {
    selected () {
      switch (this.selected) {
        case 1:
          this.screenName = '/flights-tracker/numbers/home/'
          break
        case 2:
          this.screenName = '/flights-tracker/route/home'
          break
        default:
          this.screenName = '/flights-tracker/schedule/home/'
      }
      this.gtmTrack()
    }
  }
}
</script>

<style scoped>
  .home {
    height: 100%;
    padding-top: 60px;
  }

  .iosMargin {
    margin-top: 10px;
  }

  .home van-tabs {
    color: #1E44D5;
  }
</style>
